import type { Theme } from '@mui/material/styles';
import type { SxProps, SystemStyleObject } from '@mui/system';

/** Settings shell — wider readable column on wide / 4K viewports. */
export const settingsShellSx: SxProps<Theme> = {
  width: '100%',
  maxWidth: {
    xs: '100%',
    sm: 600,
    md: 720,
    lg: 840,
    xxl: 960,
    xxxl: 1120,
  },
  mx: 'auto',
  px: { xs: 2, sm: 3, xxl: 4, xxxl: 5 },
  py: { xs: 3, xxl: 4, xxxl: 4.5 },
};

export const settingsTitleSx: SxProps<Theme> = {
  fontSize: { xs: '2rem', sm: '2.125rem', xxl: '2.375rem', xxxl: '2.625rem' },
  fontWeight: 600,
  mb: { xs: 0, xxl: 0.5 },
};

export const settingsSectionPaperSx: SxProps<Theme> = {
  p: { xs: 2, sm: 3, xxl: 3.25, xxxl: 3.5 },
  mt: { xs: 2, xxl: 2.5, xxxl: 3 },
};

export const settingsSectionTitleSx: SxProps<Theme> = {
  fontSize: { xs: '1.25rem', xxl: '1.375rem', xxxl: '1.5rem' },
  fontWeight: 600,
};

export const settingsBodyTextSx: SxProps<Theme> = {
  fontSize: { xs: '0.875rem', xxl: '0.9375rem', xxxl: '1rem' },
};

export const settingsToggleLabelSx: SystemStyleObject<Theme> = {
  fontSize: { xs: '1rem', xxl: '1.0625rem', xxxl: '1.125rem' },
};

export const settingsToggleHelperSx: SxProps<Theme> = {
  fontSize: { xs: '0.75rem', xxl: '0.8125rem', xxxl: '0.875rem' },
};

/** Board theme swatch — scales with viewport on 4K. */
export const settingsBoardThemeSwatchSx: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gridTemplateRows: 'repeat(2, 1fr)',
  width: { xs: 48, xxl: 56, xxxl: 64 },
  height: { xs: 48, xxl: 56, xxxl: 64 },
  borderRadius: 0.5,
  overflow: 'hidden',
  flexShrink: 0,
};

export const settingsBoardThemeOptionSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: { xs: 1.5, xxl: 1.75, xxxl: 2 },
  p: { xs: 1.5, xxl: 1.75, xxxl: 2 },
  borderRadius: 1,
  border: '2px solid',
  textAlign: 'left',
};

export const settingsBoardThemeLabelSx: SxProps<Theme> = {
  fontSize: { xs: '0.875rem', xxl: '0.9375rem', xxxl: '1rem' },
};

/** Autoplay gear on replay / my-games scrubber bars. */
export const replayAutoplaySettingsButtonSx: SxProps<Theme> = {
  flexShrink: 0,
  width: { lg: 32, xl: 36, xxl: 44, xxxl: 48 },
  height: { lg: 32, xl: 36, xxl: 44, xxxl: 48 },
  '& .MuiSvgIcon-root': {
    fontSize: { lg: '1.125rem', xl: '1.25rem', xxl: '1.75rem', xxxl: '2rem' },
  },
};

export const replayAutoplaySettingsPopoverPaperSx: SxProps<Theme> = {
  px: { xs: 2, xxl: 2.5, xxxl: 3 },
  py: { xs: 1.5, xxl: 2, xxxl: 2.25 },
  minWidth: { xs: 180, xxl: 220, xxxl: 260 },
  '& .MuiFormLabel-root': {
    fontSize: { xs: '0.875rem', xxl: '1rem', xxxl: '1.0625rem' },
    mb: { xs: 0.5, xxl: 0.75 },
  },
  '& .MuiFormControlLabel-label': {
    fontSize: { xs: '0.875rem', xxl: '1rem', xxxl: '1.0625rem' },
  },
};
